import { DatePicker, TimePicker } from '@mui/lab';
import { Grid } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { DateTime } from 'luxon';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';

export interface CancellationPracticeVM {
  closureDate?: DateTime | null;
  closureTime?: DateTime | null;
  closureReason?: string;
  subscriptionNumber?: string;
  dateSubscription?: DateTime | null;
}

interface AccordionPositiveClosurePracticeFormProps {
  disabled?: boolean;
  values?: CancellationPracticeVM;
  errors?: FormikErrors<CancellationPracticeVM>;
  touched?: FormikTouched<CancellationPracticeVM>;
  onChange: (
    key: keyof CancellationPracticeVM,
    value: CancellationPracticeVM[keyof CancellationPracticeVM]
  ) => void;
  isEmigr?: boolean;
}

const AccordionPositiveClosurePracticeFormComponent = ({
  disabled,
  values,
  onChange,
  touched,
  errors,
  isEmigr,
}: AccordionPositiveClosurePracticeFormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={8}>
        <DatePicker
          label="Data chiusura *"
          aria-label="Data chiusura"
          value={values?.closureDate || null}
          onChange={(date) => onChange('closureDate', date)}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="closureDate"
              fullWidth
              error={touched?.closureDate && Boolean(errors?.closureDate)}
              helperText={errors?.closureDate}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TimePicker
          label="Ora chiusura *"
          value={values?.closureTime || null}
          onChange={(date) => {
            onChange('closureTime', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              id="closureTime"
              {...params}
              fullWidth
              error={touched?.closureTime && Boolean(errors?.closureTime)}
              helperText={errors?.closureTime}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          id="closureReason"
          label="Motivo chiusura"
          aria-label="motivo"
          fullWidth
          multiline
          rows={5}
          inputProps={{
            maxLength: '100',
          }}
          onChange={(event) => {
            onChange('closureReason', event.target.value);
          }}
          value={values?.closureReason || ''}
          error={touched?.closureReason && Boolean(errors?.closureReason)}
          helperText={errors?.closureReason}
        />
      </Grid>
      {isEmigr ? (
        <>
          <Grid item xs={12} md={4}>
            <PmiTextField
              id="subscription-number"
              label="Nr. Iscrizione AIRE Consolato"
              aria-label="Nr. Iscrizione AIRE Consolato"
              fullWidth
              onChange={(event) => {
                onChange('subscriptionNumber', event.target.value);
              }}
              value={values?.subscriptionNumber || ''}
              error={touched?.subscriptionNumber && Boolean(errors?.subscriptionNumber)}
              helperText={errors?.subscriptionNumber}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DatePicker
              label="Data Iscrizione AIRE Consolato"
              aria-label="Data Iscrizione AIRE Consolato"
              value={values?.dateSubscription || null}
              onChange={(date) => onChange('dateSubscription', date)}
              disabled={disabled}
              renderInput={(params) => (
                <PmiTextField
                  {...params}
                  id="dateSubscription"
                  fullWidth
                  error={touched?.dateSubscription && Boolean(errors?.dateSubscription)}
                  helperText={errors?.dateSubscription}
                />
              )}
            />
          </Grid>
        </>
      ) : undefined}
    </Grid>
  );
};

AccordionPositiveClosurePracticeFormComponent.displayName =
  'Accordion positive closure practice form component';

const AccordionPositiveClosurePracticeForm = memo(AccordionPositiveClosurePracticeFormComponent);

export default AccordionPositiveClosurePracticeForm;
